[
  {
    "code": "DK-84",
    "name": "Region Hovedstaden"
  },
  {
    "code": "DK-82",
    "name": "Region Midtjylland"
  },
  {
    "code": "DK-81",
    "name": "Region Nordjylland"
  },
  {
    "code": "DK-85",
    "name": "Region Sjælland"
  },
  {
    "code": "DK-83",
    "name": "Region Syddanmark"
  }
]